<template>
  <div class="header-mobile-expanded__menu-block">
    <div
      v-for="(parent, parentIndex) in menuItems"
      :key="`${parent.Name}-${parentIndex}`"
      class="mobile-menu__parent-container"
    >
      <a-header-menu-block-items
        v-if="ifHasChildren(parent)"
        :parent="parent"
        @onCloseMenu="collapseHeader"
      >
        <template v-slot:bottom-items="{ onItemClick }">
          <slot
            :name="`bottom-items-${parentIndex}`"
            :on-item-click="onItemClick"
          />
        </template>
      </a-header-menu-block-items>

      <div
        v-else
        class="mobile-menu__parent-without-children"
        @click="collapseHeader"
      >
        <a-icon
          v-if="parent.Icon"
          :icon="parent.Icon"
          :width="16"
          :height="16"
          :original="true"
          :no-hover="true"
          class="mobile-menu__item-icon"
        />
        <a-link
          class="mobile-menu__single-parent-item text-primary-navigation bold"
          :to="parent.Link"
          :trailing-slash="$helper.isLinkWithTrailingSlash(parent.Link)"
        >
          {{ parent.Name }}
        </a-link>
      </div>
    </div>
  </div>
</template>

<script>
import { pathOr } from 'ramda'
import { propValidator, PROP_TYPES } from '@/utils/validators'
import AHeaderMenuBlockItems from '@/components/AHeader/AHeaderMobile/AHeaderMobileExpanded/AHeaderMenuBlock/AHeaderMenuBlockItems'
import AIcon from 'shared/AIcon/index.vue'

export default {
  name: 'AHeaderMenuBlock',
  components: { AIcon, AHeaderMenuBlockItems },
  props: {
    menuItems: propValidator([PROP_TYPES.ARRAY])
  },
  methods: {
    ifHasChildren({ ChildItems }) {
      return pathOr(0, ['length'], ChildItems) > 0
    },
    collapseHeader() {
      this.$emit('onCloseMenu')
    }
  }
}
</script>

<style lang="scss" scoped>
.header-mobile-expanded__menu-block {
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid $c--gray-dark;
}

.mobile-menu__single-parent-item {
  width: 100%;
  position: relative;
  display: block;
  cursor: pointer;
  transition: color 0.3s;
  color: white;
  padding: 16px 0;

  &:hover {
    color: $c--white;
  }
}

.mobile-menu__parent-without-children {
  width: 100%;
  display: inline-flex;
  align-items: center;
}

.mobile-menu__item-icon {
  margin-right: 6px;
}
</style>
